"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getCloudUITea: ()=>getCloudUITea,
    CnCloudUITeaFnName: ()=>CnCloudUITeaFnName,
    VaCloudUITeaFnName: ()=>VaCloudUITeaFnName
});
const external_byted_tea_sdk_namespaceObject = require("byted-tea-sdk");
const index_js_namespaceObject = require("../jwt/index.js");
const CnCloudUITeaFnName = 'cloud-ui__cn__Tea__instance__funciton__name';
const VaCloudUITeaFnName = 'cloud-ui__va__Tea__instance__funciton__name';
const initCloudUITea = (channel)=>{
    const CloudUITeaFnName = 'cn' === channel ? CnCloudUITeaFnName : VaCloudUITeaFnName;
    const appId = 'cn' === channel ? 8207 : 8208;
    const instance = new external_byted_tea_sdk_namespaceObject.Collector(CloudUITeaFnName);
    instance.init({
        app_id: appId,
        channel
    });
    var _window_location_pathname_split_;
    instance.config({
        disable_auto_pv: true,
        user_unique_id: null === index_js_namespaceObject.jwtUserInfo || void 0 === index_js_namespaceObject.jwtUserInfo ? void 0 : index_js_namespaceObject.jwtUserInfo.username,
        evtParams: {
            herf: location.href,
            domain: location.host,
            app: null != (_window_location_pathname_split_ = window.location.pathname.split('/')[1]) ? _window_location_pathname_split_ : ''
        }
    });
    instance.start();
    window[CloudUITeaFnName] = instance;
    return instance;
};
const getCloudUITea = (channel)=>{
    const CloudUITeaFnName = 'cn' === channel ? CnCloudUITeaFnName : VaCloudUITeaFnName;
    if (window[CloudUITeaFnName] && 'object' == typeof window[CloudUITeaFnName]) return window[CloudUITeaFnName];
    return initCloudUITea(channel);
};
exports.CnCloudUITeaFnName = __webpack_exports__.CnCloudUITeaFnName;
exports.VaCloudUITeaFnName = __webpack_exports__.VaCloudUITeaFnName;
exports.getCloudUITea = __webpack_exports__.getCloudUITea;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "CnCloudUITeaFnName",
    "VaCloudUITeaFnName",
    "getCloudUITea"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
